var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 141.52999877929688,
    width: 124,
    viewBox: "0 0 124 141.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.383 126.892L0 0l124 .255-10.979 126.637-50.553 14.638z",
    fill: "#1b73ba"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.468 129.275V12.085l51.064.17-9.106 104.85z",
    fill: "#1c88c7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.851 27.064H22.298l2.128 15.318h37.276l-36.68 15.745 2.127 14.808h54.043l-1.958 20.68-18.298 3.575-16.595-4.255-1.277-11.745H27.83l2.042 24.426 32.681 9.106 31.32-9.957 4-47.745H64.765l36.085-14.978z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.fe728047e3c636f4e583658cf51b7ef9.svg";
export { ForwardRef as ReactComponent };